import ProgressiveVideoLoader from 'CoreComponents/progressiveVideoLoader/';

document.querySelectorAll('.list-media__card--video').forEach(videoCard => {
  const loader = new ProgressiveVideoLoader(videoCard);

  loader.load();
});



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/progressiveVideoLoader.js